import axiosClient from "@/utils/axios-client";
import {
  PathPickMembershipApplicationsResponse,
  PathPickMembershipPlansResponse,
} from "@/features/pathpick/features/membership/types/response";

const url = {
  getPathPickMembershipPlans: (companyId: number) =>
    `/buyers/${companyId}/pathpick/plans`,
  getPathPickMembershipApplications: (companyId: number) =>
    `/buyers/${companyId}/pathpick/membership-applications`,
};

export const pathPickMembershipQueryApi = {
  // 활성 멤버십 플랜 목록 — 신청 바디에 넣을 서버 plan id를 얻는 유일한 경로다.
  getPathPickMembershipPlans: async (companyId: number) => {
    const { data } = await axiosClient.get<PathPickMembershipPlansResponse>(
      url.getPathPickMembershipPlans(companyId)
    );
    return data;
  },
  // 바이어 본인의 멤버십 신청 내역 — 입금 대기(PENDING) 중인 신청이 있는지 확인하는 데 쓴다.
  getPathPickMembershipApplications: async (companyId: number) => {
    const { data } =
      await axiosClient.get<PathPickMembershipApplicationsResponse>(
        url.getPathPickMembershipApplications(companyId)
      );
    return data;
  },
};
